<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      title="添加 冲销单"
      line-form
      :data="data"
      form-label-width="110px"
      @create-opened="onCreateOpened"
      :form-rules="rules"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="6">
              <el-form-item label="单据编号" prop="DocNo">
                <span class="detail-span" v-if="Mode==0">{{data.DocNo}}</span>
                <el-input v-else v-model="data.DocNo" placeholder="请输入单据编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker
                  type="date"
                  v-model="data.DocDate"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  @change="(v) => previewNo(v)"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="经办人" prop="ClerkId">
                <select-input
                  placeholder="请选择经办人"
                  :label="data.ClerkName"
                  v-model="data.ClerkId"
                  @click="openEmp"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="冲销类型">
                <span class="detail-span" v-if="data.CancelTypeId==0">预收冲应收</span>
                <span class="detail-span" v-if="data.CancelTypeId==1">预付冲应付</span>
                <span class="detail-span" v-if="data.CancelTypeId==2">应收冲应收</span>
                <span class="detail-span" v-if="data.CancelTypeId==3">应付冲应付</span>
                <span class="detail-span" v-if="data.CancelTypeId==4">应收冲应付</span>
                <span class="detail-span" v-if="data.CancelTypeId==5">应付冲应收</span><!--hqq-->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="FirstUnitLabel">
                <span class="detail-span">{{data.FirstUnitName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="转入结算单位" v-if="data.CancelTypeId>1">
                <span class="detail-span">{{data.SecondUnitName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总冲销金额" >
                <el-input v-model="WriteoffAmountTotal"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="data.Memo" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-row>
        <!-- 预收冲应收、预付冲应付 -->
        <template v-if="data.CancelTypeId==0||data.CancelTypeId==1">
          <div class="row-tb-head" style="margin-top: 10px;">{{Tb1Label}}</div>
          <el-table
            class="table-line tb-c-head"
            border
            show-summary
            :data="data.SRpDts"
            @selection-change="selectAll"
          >
            <!-- @selection-change="x=>data.RpDts=x" -->
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="单据日期" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="单据类型" min-width="100">
              <template slot-scope="{row}">{{row.SourceTypeName}}</template>
            </el-table-column>
            <el-table-column label="往来单位" min-width="150">
              <template slot-scope="{row}">{{row.TradeUnitName}}</template>
            </el-table-column>
            <el-table-column label="金额" prop="Amount" width="90" />
            <el-table-column label="应冲销金额" prop="NoSettleAmount" width="90" />
            <el-table-column label="冲销金额" prop="WriteoffAmount" width="120">
              <template slot-scope="{row}">
                <el-input @input="onInput(row,0)" v-model="row.WriteoffAmount"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <!-- 应收冲应付 -->
        <template v-if="data.CancelTypeId==4">
          <div class="row-tb-head" style="margin-top: 10px;">{{Tb1Label}}</div>
          <el-table
            class="tb-c-head"
            border
            show-summary
            :data="data.SRpDts"
            @selection-change="selectAll"
          >
            <!-- @selection-change="x=>data.RpDts=x" -->
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="单据日期" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="单据类型" min-width="110">
              <template slot-scope="{row}">{{row.SourceTypeName}}</template>
            </el-table-column>
            <el-table-column label="往来单位" min-width="150">
              <template slot-scope="{row}">{{row.TradeUnitName}}</template>
            </el-table-column>
            <el-table-column label="金额" prop="Amount" width="90" />
            <el-table-column label="应冲销金额" prop="NoSettleAmount" width="90" />
            <el-table-column label="冲销金额" prop="WriteoffAmount" width="120">
              <template slot-scope="{row}">
                <el-input @input="onInput(row,0)" v-model="row.WriteoffAmount"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div class="row-tb-head" style="margin-top: 10px;">{{Tb2Label}}</div>
        <el-table
          class="table-line tb-c-head"
          border
          show-summary
          :data="data.SWoDts"
          @selection-change="selectWoAll"
        >
        <!-- @selection-change="x=>data.WoDts=x" -->
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column label="单据日期" min-width="120">
            <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
          </el-table-column>
          <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.DocNo}}</template>
          </el-table-column>
          <el-table-column label="单据类型" min-width="110">
            <template slot-scope="{row}">{{row.SourceTypeName}}</template>
          </el-table-column>
          <el-table-column label="往来单位" min-width="150">
            <template slot-scope="{row}">{{row.TradeUnitName}}</template>
          </el-table-column>
          <el-table-column label="金额" prop="Amount" width="90" />
          <el-table-column label="应冲销金额" prop="NoSettleAmount" width="90" /> 
          <el-table-column label="冲销金额" prop="WriteoffAmount" width="120">
            <template slot-scope="{row}">
              <el-input @input="onInput(row,1)" v-model="row.WriteoffAmount"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <!-- 应付冲应收 -->
      <template v-if="data.CancelTypeId==5">
        <div class="row-tb-head" style="margin-top: 10px;">{{Tb1Label}}</div>
        <el-table
          class="tb-c-head"
          border
          show-summary
          :data="data.SRpDts"
          @selection-change="selectAll"
        >
          <!-- @selection-change="x=>data.RpDts=x" -->
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column label="单据日期" min-width="120">
            <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
          </el-table-column>
          <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.DocNo}}</template>
          </el-table-column>
          <el-table-column label="单据类型" min-width="110">
            <template slot-scope="{row}">{{row.SourceTypeName}}</template>
          </el-table-column>
          <el-table-column label="往来单位" min-width="150">
            <template slot-scope="{row}">{{row.TradeUnitName}}</template>
          </el-table-column>
          <el-table-column label="金额" prop="Amount" width="90" />
          <el-table-column label="应冲销金额" prop="NoSettleAmount" width="90" />
          <el-table-column label="冲销金额" prop="WriteoffAmount" width="120">
            <template slot-scope="{row}">
              <el-input @input="onInput(row,0)" v-model="row.WriteoffAmount"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import empDialog from "@/components/personnel/result/record/listDialog";
import { number } from 'echarts/lib/export';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog,
  },
  data() {
    return {
      api: require("@/api/rp/rpSettleDoc").default,
      code_api: require("@/api/sy/serialCode").default,
      woDoc_api: require("@/api/rp/rpWoDoc").default,
      receipt_api: require("@/api/rp/rpReceiptDoc").default,
      pay_api: require("@/api/rp/pay").default,
      data: {
        SettleDocId: 0,
        CancelTypeId: 0, //收款冲销/付款冲销
        DocNo: "",
        FirstUnitId: null,
        FirstUnitName: "",
        SecondUnitId: null,
        SecondUnitName: "",
        DocDate: this.$commonJs.getToday(),
        ClerkId: null,
        ClerkName: "",
        Memo: "",
        RpDts: [], //冲销单收付款单
        SRpDts: [],
        WoDts: [], //冲销单冲销明细
        SWoDts: [],
        WoDts2: [],
        SWoDts2: [],
      },
      Mode: 0,
      rules: {
        DocNo: [{ required: true, message: "收入单编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        ClerkId: [{ required: true, message: "请选择经办人" }],
      },
      checkedRpRows:[],
      checkedWoRows:[],
      WriteoffAmountTotal: 0
    };
  },
  computed: {
    FirstUnitLabel() {
      if (this.data.CancelTypeId < 2) return "往来单位";
      else return "转出结算单位";
    },
    Tb1Label() {
      if (this.data.CancelTypeId == 0) return "预收明细";
      else if (this.data.CancelTypeId == 1) return "预付明细";
      else if (this.data.CancelTypeId == 4) return "应收明细";
      else if (this.data.CancelTypeId == 5) return "应收明细"; //hqq
      else return "单据明细";
    },
    Tb2Label() {
      if (this.data.CancelTypeId == 0) return "应收明细";
      else if (this.data.CancelTypeId == 1) return "应付明细";
      else if (this.data.CancelTypeId == 4) return "应付明细";
      else if (this.data.CancelTypeId == 5) return "应付明细"; //hqq
      else return "单据明细";
    },
    // SelectAmount() {
    //   var list = this.data.RpDts.map((x) => x.WriteoffAmount);
    //   if (list.length > 0) return list.reduce((a, b) => a + b);
    //   else return 0;
    // },
  },
  watch: {
    // SelectAmount() {
    //   var s_amount = this.SelectAmount;
    //   for (let i = 0; i < this.data.SWoDts.length; i++) {
    //     var ns_amount = this.data.SWoDts[i].NoSettleAmount;
    //     var amount = s_amount - ns_amount;
    //     console.log("s_amount - ns_amount", amount);
    //     if (amount >= 0) {
    //       this.data.SWoDts[i].WriteoffAmount = ns_amount;
    //       s_amount = amount;
    //     } else {
    //       this.data.SWoDts[i].WriteoffAmount = s_amount;
    //       break;
    //     }
    //   }
    // },
  },
  methods: {
    /** 第一个表格的勾选事件 */
    selectAll(valueArrary){
      /** 如果打钩了冲销金额为0 否则冲销金额等于NoSettleAmount */
      this.checkedRpRows = valueArrary;
      this.checkedRpRows.forEach((x)=>{
        if(x.WriteoffAmount==0){
          x.WriteoffAmount=x.NoSettleAmount
        }
      });
      this.data.SRpDts.forEach((x)=>{
        if (this.data.CancelTypeId != 5){ //hqq
          var check=this.checkedRpRows.find((item)=>{return item.Index==x.Index});
          if(!check){
            x.WriteoffAmount=0
          }else{
            x.WriteoffAmount=check.WriteoffAmount;
          }
        }
        else { 
          //hqq
          x.WriteoffAmount=0;
          var check=this.checkedRpRows.find((item)=>{return item.Index==x.Index});
          if(check!==null&&check){
            if(x.WriteoffAmount===0){
              console.log('w1', x.WriteoffAmount);
              x.WriteoffAmount=x.NoSettleAmount
            }else{
              x.WriteoffAmount=check?.WriteoffAmount;
              console.log('w2', x.WriteoffAmount);
            }
          }
          //hqq
        }
      });  
      this.changeAmount();
    },
    /** 第二个表格的勾选事件 */
    selectWoAll(valueArrary){
      this.checkedWoRows=valueArrary;         
      this.checkedWoRows.forEach((x)=>{
        if(x.WriteoffAmount===0){
          x.WriteoffAmount=x.NoSettleAmount
        }
      });   
      this.data.SWoDts.forEach((x)=>{
          if (this.data.CancelTypeId != 5){ //hqq
            x.WriteoffAmount=0;
            var check=this.checkedWoRows.find((item)=>{return item.Index==x.Index});      
            if(check!==null&&check){
              if(x.WriteoffAmount===0){
                x.WriteoffAmount=x.NoSettleAmount
              }else{
                x.WriteoffAmount=check?.WriteoffAmount;
              }
            }
          }
          else {
            //hqq
            var check=this.checkedWoRows.find((item)=>{return item.Index==x.Index});      
            if(!check){
              x.WriteoffAmount=0
            }else{
              x.WriteoffAmount=check.WriteoffAmount;
            }
            //hqq
          }
        });
      this.changeAmount();
    },
    //hqq 原来
    // changeAmount(){
    //   /** 获取第一个表格勾选的总冲销金额 */
    //   var list = this.checkedRpRows.map((x) => x.WriteoffAmount);
    //   var s_amount = 0;
    //   if (list.length > 0) {
    //     s_amount = list.reduce((a, b) => Number(a) + Number(b));
    //   }
    //   console.log("s_amount",s_amount);
    //   /** 若没有勾选的数据，冲销金额设置为0 */
    //   /** 第一个表格没勾选 || 第二个表格没勾选 */
    //   if(this.checkedRpRows?.length==0||this.checkedWoRows?.length==0){
    //     if(this.data.CancelTypeId==0||this.data.CancelTypeId==1||this.data.CancelTypeId==4||this.data.CancelTypeId==5){
    //       /** 第二个表格的冲销金额设置为0 */
    //       this.data.SWoDts.forEach((x)=>{          
    //         console.log("s_amount1",s_amount);
    //         x.WriteoffAmount=0
    //       });
    //     }
    //   }


    //   /** 若只显示 应收冲应收 || 应付冲应付 （只显示一个表格 （第二个表格）） */
    //   if(this.data.CancelTypeId == 2 || this.data.CancelTypeId == 3){
    //     /** 第二个表格赋值冲销金额 */
    //     if(this.checkedWoRows&&this.checkedWoRows.length>0){
    //       this.checkedWoRows.forEach((x)=>{
    //         x.WriteoffAmount=0
    //       });
    //       var sumWA_amount = this.WriteoffAmountTotal //总冲销金额
    //       for (let i = 0; i < this.checkedWoRows.length; i++) {
    //         /** 冲销金额 = 总冲销金额 - 应冲销金额 */
    //         var ns_amount = this.checkedWoRows[i].NoSettleAmount;
    //         var amount = Number((sumWA_amount - ns_amount).toFixed(2));
    //         if (amount >= 0) {
    //           this.checkedWoRows[i].WriteoffAmount = ns_amount;
    //           sumWA_amount = amount;
    //         } else {
    //           this.checkedWoRows[i].WriteoffAmount = sumWA_amount;
    //           break;
    //         }
    //       }
    //     }
    //   }else{
    //     /** 第二个表格赋值冲销金额 */
    //     if(this.checkedWoRows&&this.checkedWoRows.length>0&&s_amount!=0){
    //       console.log("s_amount2",s_amount);
    //       this.checkedWoRows.forEach((x)=>{
    //         x.WriteoffAmount=0
    //       });
    //       for (let i = 0; i < this.checkedWoRows.length; i++) {
    //         /** 冲销金额 = 总冲销金额 - 应冲销金额 */
    //         var ns_amount = this.checkedWoRows[i].NoSettleAmount;
    //         var amount = Number((s_amount - ns_amount).toFixed(2));
    //         console.log("s_amount - ns_amount", amount);
    //         if (amount >= 0) {
    //           this.checkedWoRows[i].WriteoffAmount = ns_amount;
    //           s_amount = amount;
    //         } else {
    //           this.checkedWoRows[i].WriteoffAmount = s_amount;
    //           break;
    //         }
    //       }
    //     }
    //   }
      
    //   /** 第一个表格赋值冲销金额 */
    //   if(this.checkedRpRows&&this.checkedRpRows.length>0&&this.WriteoffAmountTotal!=0){
    //     this.checkedRpRows.forEach((x)=>{
    //       x.WriteoffAmount=0
    //     });
    //     var sum_amount = this.WriteoffAmountTotal //总冲销金额
    //     for (let i = 0; i < this.checkedRpRows.length; i++) {
    //       /** 冲销金额 = 总冲销金额 - 应冲销金额 */
    //       var ns_amount = this.checkedRpRows[i].NoSettleAmount;//应冲销金额
    //       var amount = Number((sum_amount - ns_amount).toFixed(2)); //冲销金额
    //       if (amount >= 0) {
    //         this.checkedRpRows[i].WriteoffAmount = ns_amount;
    //         sum_amount = amount;
    //       } else {
    //         this.checkedRpRows[i].WriteoffAmount = sum_amount;
    //         break;
    //       }
    //     }
    //   }
      

    // },
    
    firstCheckRows(){ //hqq
      if (this.data.CancelTypeId == 5)
      {
        console.log('first');
        return this.checkedWoRows;
      }
      else
        return this.checkedRpRows; 
    },
    secondCheckRows(){ //hqq
      if (this.data.CancelTypeId == 5)
      {
        return this.checkedRpRows;
      }
      else
        return this.checkedWoRows; 
    }, 
    firstDatas(){ //hqq
      if (this.data.CancelTypeId == 5)
      {
        return this.data.SWoDts;
      }
      else
        return this.data.SRpDts;
    },
    secondDatas(){ //hqq
      if (this.data.CancelTypeId == 5)
      {
        return this.data.SRpDts;
      }
      else
        return this.data.SWoDts;
    },
    changeAmount(){ //hqq

      /** 获取第一个表格勾选的总冲销金额 */
      var list = this.firstCheckRows().map((x) => x.WriteoffAmount);
      var s_amount = 0;
      if (list.length > 0) {
        s_amount = list.reduce((a, b) => Number(a) + Number(b));
      }
      console.log("s_amount",s_amount);
      /** 若没有勾选的数据，冲销金额设置为0 */
      /** 第一个表格没勾选 || 第二个表格没勾选 */
      if(this.firstCheckRows()?.length==0||this.secondCheckRows()?.length==0){
        if(this.data.CancelTypeId==0||this.data.CancelTypeId==1||this.data.CancelTypeId==4||this.data.CancelTypeId==5){
          /** 第二个表格的冲销金额设置为0 */
          this.secondDatas().forEach((x)=>{          
            console.log("s_amount1",s_amount);
            x.WriteoffAmount=0
          });
        }
      }


      /** 若只显示 应收冲应收 || 应付冲应付 （只显示一个表格 （第二个表格）） */
      if(this.data.CancelTypeId == 2 || this.data.CancelTypeId == 3){
        /** 第二个表格赋值冲销金额 */
        if(this.secondCheckRows()&&this.secondCheckRows().length>0){
          this.secondCheckRows().forEach((x)=>{
            x.WriteoffAmount=0
          });
          var sumWA_amount = this.WriteoffAmountTotal //总冲销金额
          for (let i = 0; i < this.secondCheckRows().length; i++) {
            /** 冲销金额 = 总冲销金额 - 应冲销金额 */
            var ns_amount = this.secondCheckRows()[i].NoSettleAmount;
            var amount = Number((sumWA_amount - ns_amount).toFixed(2));
            if (amount >= 0) {
              this.secondCheckRows()[i].WriteoffAmount = ns_amount;
              sumWA_amount = amount;
            } else {
              this.secondCheckRows()[i].WriteoffAmount = sumWA_amount;
              break;
            }
          }
        }
      }else{
        /** 第二个表格赋值冲销金额 */
        if(this.secondCheckRows()&&this.secondCheckRows().length>0&&s_amount!=0){
          console.log("s_amount2",s_amount);
          this.secondCheckRows().forEach((x)=>{
            x.WriteoffAmount=0
          });
          for (let i = 0; i < this.secondCheckRows().length; i++) {
            /** 冲销金额 = 总冲销金额 - 应冲销金额 */
            var ns_amount = this.secondCheckRows()[i].NoSettleAmount;
            var amount = Number((s_amount - ns_amount).toFixed(2));
            console.log("s_amount - ns_amount", amount);
            if (amount >= 0) {
              this.secondCheckRows()[i].WriteoffAmount = ns_amount;
              s_amount = amount;
            } else {
              this.secondCheckRows()[i].WriteoffAmount = s_amount;
              break;
            }
          }
        }
      }
      
      /** 第一个表格赋值冲销金额 */
      if(this.firstCheckRows()&&this.firstCheckRows().length>0&&this.WriteoffAmountTotal!=0){
        this.firstCheckRows().forEach((x)=>{
          x.WriteoffAmount=0
        });
        var sum_amount = this.WriteoffAmountTotal //总冲销金额
        for (let i = 0; i < this.firstCheckRows().length; i++) {
          /** 冲销金额 = 总冲销金额 - 应冲销金额 */
          var ns_amount = this.firstCheckRows()[i].NoSettleAmount;//应冲销金额
          var amount = Number((sum_amount - ns_amount).toFixed(2)); //冲销金额
          if (amount >= 0) {
            this.firstCheckRows()[i].WriteoffAmount = ns_amount;
            sum_amount = amount;
          } else {
            this.firstCheckRows()[i].WriteoffAmount = sum_amount;
            break;
          }
        }
      }
      

    },

    previewNo(dataTime = ""){
      this.code_api.previewNo("冲销单", dataTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取冲销单编号失败");
        }
      });
    },
    onCreateOpened(data) {
      
      this.previewNo();
      this.data.CancelTypeId = data.BusinessType;
      this.data.FirstUnitId = data.FirstUnitId;
      this.data.FirstUnitName = data.FirstUnitName;
      this.data.SecondUnitId = data.SecondUnitId;
      this.data.SecondUnitName = data.SecondUnitName;

      var user = this.$store.state.user;
      // console.log("user", user);
      this.data.ClerkId = user.id;
      this.data.ClerkName = user.name;

      var params = {
        DocDateStart: data.DocDateStart,
        DocDateEnd: data.DocDateEnd,
      };

      console.log('CancelTypeId', this.data.CancelTypeId); //hqq

      //预收冲应收、预付冲应付、应收冲应收、应付冲应付、应收冲应付、 应付冲应收
      if (this.data.CancelTypeId == 0) {
        var params1 = {
          ...params,
          TradeUnitId: data.FirstUnitId,
          BusinessTypes: [1],
        };
        this.alreadyList(params1, "receipt");
        var params2 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params2, "needRcvDetail");
      } else if (this.data.CancelTypeId == 1) {
        var params1 = {
          ...params,
          TradeUnitId: data.FirstUnitId,
          BusinessTypes: [1],
        };
        this.alreadyList(params1, "pay");
        var params2 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params2, "needPayDetail");
      } else if (this.data.CancelTypeId == 2) {
        var params1 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params1, "needRcvDetail");
      } else if (this.data.CancelTypeId == 3) {
        var params1 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params1, "needPayDetail");
      } else if (this.data.CancelTypeId == 4) {
        var params1 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params1, "needRcvDetail", "SRpDts");
        var params2 = { ...params, TradeUnitId: data.SecondUnitId };
        this.needDetail(params2, "needPayDetail");
      } else if (this.data.CancelTypeId == 5) {
        var params1 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params1, "needPayDetail");
        var params2 = { ...params, TradeUnitId: data.SecondUnitId };
        this.needDetail(params2, "needRcvDetail", "SRpDts");
      }

      console.log('this.data', this.data)
    },
    alreadyList(params, type) {
      var func = this.pay_api.alreadyPayDocList;
      if (type == "pay") func = this.pay_api.alreadyPayDocList;
      else func = this.receipt_api.alreadyList;

      func(params).then((res) => {
        if (res.Data) {
          this.data.SRpDts = res.Data.map((x, i) => {
            var amount = type == "pay" ? x.PayAmount : x.ReceiptAmount;
            return {
              Index: i,
              SettleDocRpId: 0,
              SettleDocId: this.data.SettleDocId,
              SourceTypeId: x.SourceTypeId,
              SourceTypeName: x.SrcVouTypeName,
              DocId: x.DocId,
              DocNo: x.DocNo,
              TradeUnitId: x.TradeUnitId,
              TradeUnitName: x.TradeUnitName,
              DocDate: x.DocDate,
              // DpId: null,
              ClerkId: x.EmpId,
              ClerkName: x.EmpName,
              // ProjectId: null,
              Amount: amount,
              NoSettleAmount: Number(Number(amount - x.WriteoffAmount).toFixed(2)),
              WriteoffAmount: Number(Number(amount - x.WriteoffAmount).toFixed(2)),
              TotalAmount: x.WriteoffAmount,
              Memo: "",
              BusinessTypeId: x.BusinessType,
              SourceVoucherId: x.SourceId,
              SourceVoucherTypeId: x.SourceType,
              SourceCode: x.SourceNo,
              IsSelected: false,
              T: 0,
            };
          });
          console.log('this.data.SRpDts', this.data.SRpDts)
        }
      });
    },
    needDetail(data, type, listType = "SWoDts") {
      console.log("listType", listType);
      this.woDoc_api[type](data).then((res) => {
        if (res.Data) {
          this.data[listType] = res.Data.map((x, i) => {
            return {
              Index: i,
              SettleDocWoId: 0,
              SettleDocId: this.data.SettleDocId,
              SourceTypeId: x.SrcVouType,
              SourceTypeName: x.SrcVouTypeName,
              DocId: x.SourceId,
              DetailId: x.DetailId,
              DetailName: x.DetailName,
              DocNo: x.DocNo,
              // TypeId: 0,
              TradeUnitId: x.TradeUnitId,
              TradeUnitName: x.TradeUnitName,
              DocDate: x.DocDate,
              DpId: x.DpId,
              DpName: x.DpName,
              ClerkId: x.EmpId,
              ClerkName: x.EmpName,
              // ProjectId: 0,
              Amount: x.Amount,
              NoSettleAmount: Number(Number(x.Amount - x.WriteoffAmount).toFixed(2)),
              WriteoffAmount: 0,
              TotalAmount: x.WriteoffAmount,
              Memo: "",
              BusinessTypeId: 0,
              SourceVoucherId: x.SourceId,
              SourceVoucherTypeId: x.SrcVouType,
              // SourceCode: null,
              IsSelected: false,
              T: 0,
            };
          });
        }
      });
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    /** 全部表格的冲销金额输入事件 */
    onInput(row,ctype=0) {
      row.T = row.T == 0 ? 0 : 1;
      row.WriteoffAmount = this.$commonJs.obj.toNumber(row.WriteoffAmount);
      if (row.WriteoffAmount > row.NoSettleAmount) {
        row.WriteoffAmount = row.NoSettleAmount;
      }
      // if(ctype==0){
      //   this.changeAmount();
      // }
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        this.data.RpDts=this.checkedRpRows;
        this.data.WoDts=this.checkedWoRows;
        if (this.data.CancelTypeId == 0 || this.data.CancelTypeId == 1) {
          if (this.data.RpDts.length == 0) {
            this.$message.warning("请选择" + this.Tb1Label);
            return;
          }
          // var amount1 = this.data.RpDts.some((x) => x.WriteoffAmount <= 0);
          // if (amount1) {
          //   this.$message.warning(
          //     this.Tb1Label + " - 本次冲销金额不能为空且需大于0"
          //   );
          //   return false;
          // }
        }

        if (this.data.CancelTypeId == 4) {
          if (this.data.RpDts.length == 0) {
            this.$message.warning("请选择应收明细");
            return;
          }
          // var amount1 = this.data.RpDts.some((x) => x.WriteoffAmount <= 0);
          // if (amount1) {
          //   this.$message.warning("应收明细 - 本次冲销金额不能为空且需大于0");
          //   return false;
          // }
        }

        if (this.data.WoDts.length == 0) {
          this.$message.warning("请选择" + this.Tb2Label);
          return;
        }
        // var amount2 = this.data.WoDts.some((x) => x.WriteoffAmount <= 0);
        // if (amount2) {
        //   this.$message.warning(
        //     this.Tb2Label + " - 本次冲销金额不能为空且需大于0"
        //   );
        //   return false;
        // }

        if (this.data.CancelTypeId == 0 || this.data.CancelTypeId == 1) {
          var total1 = this.data.RpDts.map((x) => x.WriteoffAmount).reduce(
            (a, b) => parseFloat(a) + parseFloat(b)
          );
          var total2 = this.data.WoDts.map((x) => x.WriteoffAmount).reduce(
            (a, b) => parseFloat(a) + parseFloat(b)
          );
          if (total1 != total2) {
            var text1 = "已选" + this.Tb1Label + "金额总和";
            var text2 = "已选" + this.Tb2Label + "金额总和";
            this.$message.warning(text1 + "需等于" + text2);
            return false;
          }
        }

        if (this.data.CancelTypeId == 4 || this.data.CancelTypeId == 5) {
          var total1 = this.data.RpDts.map((x) => x.WriteoffAmount).reduce(
            (a, b) => parseFloat(a) + parseFloat(b)
          );
          var total2 = this.data.WoDts.map((x) => x.WriteoffAmount).reduce(
            (a, b) => parseFloat(a) + parseFloat(b)
          );
          if (total1 != total2) {
            var text1 = "已选" + this.Tb1Label + "金额总和";
            var text2 = "已选" + this.Tb2Label + "金额总和";
            this.$message.warning(text1 + "需等于" + text2);
            return false;
          }
        }

        var data = this.$commonJs.obj.removeNullKey(this.data);
        data?.RpDts.forEach(item => {
          if(item.NoSettleAmount.toString().indexOf('.') !== -1){
            item.NoSettleAmount = parseFloat(Number(item.NoSettleAmount).toFixed(2))
          }
          if(item.WriteoffAmount.toString().indexOf('.') !== -1){
            item.WriteoffAmount = parseFloat(Number(item.WriteoffAmount).toFixed(2))
          }
          
        })
   
        data?.SRpDts.forEach(item => {
          if(item.NoSettleAmount.toString().indexOf('.') !== -1){
            item.NoSettleAmount = parseFloat(Number(item.NoSettleAmount).toFixed(2))
          }
          if(item.WriteoffAmount.toString().indexOf('.') !== -1){
            item.WriteoffAmount = parseFloat(Number(item.WriteoffAmount).toFixed(2))
          }
          
        })

        data?.WoDts.forEach(item => {
          if(item.NoSettleAmount.toString().indexOf('.') !== -1){
            item.NoSettleAmount = parseFloat(Number(item.NoSettleAmount).toFixed(2))
          }
          if(item.WriteoffAmount.toString().indexOf('.') !== -1){
            item.WriteoffAmount = parseFloat(Number(item.WriteoffAmount).toFixed(2))
          }
          
        })

        data?.SWoDts.forEach(item => {
          if(item.NoSettleAmount.toString().indexOf('.') !== -1){
            item.NoSettleAmount = parseFloat(Number(item.NoSettleAmount).toFixed(2))
          }
          if(item.WriteoffAmount.toString().indexOf('.') !== -1){
            item.WriteoffAmount = parseFloat(Number(item.WriteoffAmount).toFixed(2))
          }
          
        })

        data?.WoDts2.forEach(item => {
          if(item.NoSettleAmount.toString().indexOf('.') !== -1){
            item.NoSettleAmount = parseFloat(Number(item.NoSettleAmount).toFixed(2))
          }
          if(item.WriteoffAmount.toString().indexOf('.') !== -1){
            item.WriteoffAmount = parseFloat(Number(item.WriteoffAmount).toFixed(2))
          }
          
        })

        data?.SWoDts2.forEach(item => {
          if(item.NoSettleAmount.toString().indexOf('.') !== -1){
            item.NoSettleAmount = parseFloat(Number(item.NoSettleAmount).toFixed(2))
          }
          if(item.WriteoffAmount.toString().indexOf('.') !== -1){
            item.WriteoffAmount = parseFloat(Number(item.WriteoffAmount).toFixed(2))
          }
          
        })
        if(data.RpDts && data.RpDts.length > 0) {
          data.RpDts = data.RpDts.filter(x => x.WriteoffAmount > 0);
        }
        if(data.WoDts && data.WoDts.length > 0) {
          data.WoDts = data.WoDts.filter(x => x.WriteoffAmount > 0);
        }
        console.log("保存", this.$commonJs.toJson(data));
        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.data.RpDts = []; //冲销单收付款单
      this.data.SRpDts = [];
      this.data.WoDts = []; //冲销单冲销明细
      this.data.SWoDts = [];
      this.data.WoDts2 = []; //冲销单冲销明细2
      this.data.SWoDts2 = [];
      this.WriteoffAmountTotal = 0
    },
  },
};
</script> 